var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.2 0 16.082c0 8.063 5.91 14.721 13.608 15.884V20.345H9.649v-4.227h3.959v-2.813c0-4.657 2.257-6.7 6.108-6.7 1.844 0 2.82.137 3.281.199v3.69h-2.626c-1.635 0-2.206 1.558-2.206 3.314v2.31h4.791l-.65 4.227h-4.14V32C25.974 30.936 32 24.224 32 16.082 32 7.201 24.836 0 16 0z",
    fill: "#fff"
  })));
}
export default SvgFacebookIcon;